import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1bb1f090&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1bb1f090&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1f090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb1f090')) {
      api.createRecord('1bb1f090', component.options)
    } else {
      api.reload('1bb1f090', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1bb1f090&scoped=true", function () {
      api.rerender('1bb1f090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/link/error/index.vue"
export default component.exports